<script setup lang="ts">
import { useFormComposable } from '@src/form/composables/form-composable.js';
import { reactive, useCssModule } from 'vue';
import PasswordInput from '@components/form/password-input.vue';
import Input from '@components/form/input.vue';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';
import Button from '@components/buttons/button.vue';
import type { LoginRequest } from '@src/application/interfaces/login-request.js';

const props = defineProps<{
    modelValue: LoginRequest,
}>();

const emit = defineEmits<{
    submit: [submitted: LoginRequest],
}>();

const modelValue = reactive<LoginRequest>(props.modelValue);
const { form: passwordForm } = useFormComposable(modelValue, () => {
    if (modelValue.username === null || modelValue.password === null) {
        return;
    }
    modelValue['login-token'] = null;
    emit('submit', modelValue);
});

const { form: tokenForm } = useFormComposable(modelValue, () => {
    if (modelValue['login-token'] === null) {
        return;
    }
    modelValue.username = null;
    modelValue.password = null;
    emit('submit', modelValue);
});

async function onClick() {
    if (modelValue.password) {
        await passwordForm.submit();
        return;
    }
    await tokenForm.submit();
}

const styles = useCssModule();
</script>

<template>
    <VerticalAlignChildrenWrapper gap-top="3">
        <Input name="username" :required="!modelValue['login-token']" label="Benutzername" :form="passwordForm"/>
        <PasswordInput
            name="password"
            label="Passwort"
            :form="passwordForm"
        />
        <p :class="styles.separator">oder</p>
        <PasswordInput
            name="login-token"
            label="Tages-Login"
            :autofocus="true"
            :form="tokenForm"
        />
        <CenterChildrenWrapper>
            <Button context="primary" :class="styles.login_button" @click="onClick">Jetzt einloggen</Button>
        </CenterChildrenWrapper>
    </VerticalAlignChildrenWrapper>
</template>

<style lang="scss" module>
@use '@borders' as *;

.separator {
    position: relative;
    display: block;
    width: 100%;
    text-align: center;

    &::before, &::after {
        position: absolute;
        top: 50%;
        display: block;
        width: calc( 50% - 1.8em );
        height: 1px;
        content: '';
        background-color: $default-line-color;
    }
    &::before {
        left: 0;
    }
    &::after {
        right: 0;
    }
}
.login_button {
    min-width: 11em;
}
</style>
